import { useNotificationsStore, type PopupOptions } from "./store"

export default (options: PopupOptions | { loading?: boolean }) => {
  const notificationsStore = useNotificationsStore()
  if (options.loading === true) {
    notificationsStore.startLoading()
  } else if (options.loading === false) {
    notificationsStore.loadingDone()
  } else {
    if (options.duration === undefined) {
      options.duration = 2000
    } else if (options.duration < 500) {
      console.warn(`Notify duration < 500 is not allowed: ${options.duration}`)
      options.duration = 2000
    }
    notificationsStore.setpopup(options)
  }
}
